<template>
  <div class="col-lg-6">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Osnovni podaci</h4>
      </div>
      <div class="card-body">
        <b-list-group>
          <!-- IME -->
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            <span>Ime</span>
            <span class="bold">{{ userData ? userData.firstName : "" }}</span>
          </b-list-group-item>
          <!-- PREZIME -->
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            <span>Prezime</span>
            <span class="bold">{{ userData ? userData.lastName : "" }}</span>
          </b-list-group-item>
          <!-- KORISNICKO IME -->
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            <span>Korisničko ime</span>
            <span class="bold">{{ userData ? userData.username : "" }}</span>
          </b-list-group-item>
          <!-- EMAIL -->
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            <span>Email</span>
            <span class="bold">{{ userData ? userData.email : "" }}</span>
          </b-list-group-item>
          <!-- POL -->
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            <span>Pol</span>
            <span class="bold">{{
              userData ? (userData.gender == 0 ? "Muški" : "Ženski") : ""
            }}</span>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </div>
</template>

<script>
import { BListGroup, BListGroupItem } from "bootstrap-vue";
export default {
  components: {
    BListGroup,
    BListGroupItem,
  },
  computed: {
    userData() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
};
</script>

<style lang="scss" scoped>
.bold {
  font-weight: bold;
}
</style>
